import { Directive, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, map } from 'rxjs';
import { interval } from 'rxjs/internal/observable/interval';
import { AutosaveAction } from './enum/autosave-action.enum';

export const SAVE_INTERVAL = 5000;

@Directive({
  selector: '[appFocusAutosave]'
})
export class FocusAutosaveDirective implements OnDestroy {
    @Output() appFocusAutosave = new EventEmitter<AutosaveAction>();

    private updateInterval?: Subscription;

    constructor() { }

    @HostListener('onSelectionChange') // Quill editor event
    @HostListener('focusin')
    @HostListener('focus')      // input Focus In event capture
    onFocus() {
        this.updateInterval?.unsubscribe();
        this.updateInterval = interval(SAVE_INTERVAL)
            .pipe(
                map(() => this.appFocusAutosave.emit(AutosaveAction.TIMER))
            ).subscribe();
    }


    @HostListener('onBlur')     // Quill editor blur event
    @HostListener('focusout')   // input Focus Out event capture
    onFocusOut() {
        this.updateInterval?.unsubscribe();
        this.appFocusAutosave.emit(AutosaveAction.FOCUS_OUT);
    }

    ngOnDestroy(): void {
        this.updateInterval?.unsubscribe();
        this.appFocusAutosave.emit(AutosaveAction.ON_DESTROY);
    }
}
